import { supabase } from '@/integrations/supabase/client';
export type SkillsEvent = 'skills_directory_visit' | 'skill_detail_view' | 'skills_search' | 'skills_filter' | 'skill_source_click' | 'skill_command_copy' | 'skill_submit_click';
/** Reuse insert-only event storage; never store queries, commands, URLs, or user IDs. */
export function trackSkills(event: SkillsEvent, label?: string) {
  try {
    let id = sessionStorage.getItem('skills_sid');
    if (!id) { id = crypto.randomUUID(); sessionStorage.setItem('skills_sid', id); }
    void supabase.from('homepage_events').insert({ event_name: event, session_id: id, variant: 'skills_v1', label: label?.slice(0, 60) ?? null }).then(() => undefined, () => undefined);
  } catch { /* analytics never interrupts discovery */ }
}